import styled from 'styled-components';

import { Container, ContentContainer } from '../../components/Wrapper/Wrapper';
import TileHeader from '../../components/TileHeader/TileHeader';

const NotFound = () => {

  return (
    <Container>
      <ContentContainer>

      <TileHeader 
        title="404 - Page Not Found"
        size="lg"
      />

      </ContentContainer>
    </Container>
  );
};

export default NotFound;